
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import { DatePicker, Space } from 'antd';
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import dayjs from 'dayjs';
const dateFormat = 'DD/MM/YYYY';

const DescuentoForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, cursoCombo, fechas})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Descuento"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >  
                            <Form.Field  required  error={errors.cursoId}>
                              <label  >{strings?strings["cursoId"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["cursoId"]:""} 
                                    name="cursoId"
								    fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.cursoId}
                                    options={cursoCombo}/>
                            </Form.Field>
        
        
                            <Form.Field  required  error={errors.porcentaje}>            
                              <label  >{strings?strings["porcentaje"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["porcentaje"]:""} 
                                    name="porcentaje"
                                    onChange={onChange}
                                    value={datos.porcentaje}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.iniciales}>            
                              <label  >{strings?strings["iniciales"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["iniciales"]:""} 
                                    name="iniciales"
                                    onChange={onChange}
                                    value={datos.iniciales}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.noCupones}>            
                              <label  >{strings?strings["noCupones"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["noCupones"]:""} 
                                    name="noCupones"
                                    onChange={onChange}
                                    value={datos.noCupones}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.fechaGenerado}>            
                              <label  >{strings?strings["fechaGenerado"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["fechaGenerado"]:""} 
                                    name="fechaGenerado"
                                    onChange={onChange}
                                    disabled={true}
                                    value={datos.fechaGenerado}
                                    icon='edit'/>
                            </Form.Field>
                                            
                        <label  >{strings?strings["fechaVigencia"]:""}</label>
                             <DatePicker bordered={false}                  
                                    onChange={(dates, dateStrings)=>fechas(dates, dateStrings)} 
                                    locale={locale} 
                                    size="large" 
                                    value={dayjs(datos.fechaVigencia, dateFormat)}
                                    allowClear={false}
                                    format={dateFormat} /> 
                                            
                         
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/descuentos">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default DescuentoForm;